module.exports = __webpack_public_path__ + "img/dudaoxinxi.c21cdaa1.png";